module.exports = __webpack_public_path__ + "img/paperclip-vertical.e489f250.svg";